import { SourcingStageType } from 'api-clients/monolith';

export const STAGE_TYPES: Record<SourcingStageType, string> = {
  landing: 'Apply',
  assess: 'Assess',
  screening: 'Screen',
  interview: 'Interview',
  offer: 'Offer',
  hired: 'Hire',
} as const;
